<template>
  <div class="Program-view-page w-100">
    <b-overlay
      :show="loading"
      rounded
      opacity="0.8"
      spinner-variant="success"
      spinner-small="false"
      spinner-type="border"
      spinner-size="lg"
    >
      <basic-subheader>
        <template v-slot:actions>
          <div class="header-buttons-container">
            <b-button
              v-if="isInsertPermission"
              class="btn btn-success"
              type="button"
              @click="showAddModuleModal"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
              </span>
              Thêm module
            </b-button>

            <div class="navigation-buttons">
              <b-button class="btn ml-3" type="button" @click="returnPage">
                <span class="svg-icon">
                  <inline-svg
                    src="/media/svg/icons/Neolex/Arrows/arrow-left.svg"
                  />
                </span>
                Trở về trước
              </b-button>
              <b-button
                class="btn ml-3 custom-btn"
                type="button"
                @click="toggleViewMode"
              >
                <span class="toggle-container">
                  <span
                    class="toggle-text"
                    :class="{ active: viewMode !== 'week' }"
                    >Theo ngày</span
                  >
                  |
                  <span
                    class="toggle-text"
                    :class="{ active: viewMode === 'week' }"
                    >Theo tuần</span
                  >
                </span>
              </b-button>
            </div>
          </div>
        </template>
      </basic-subheader>
      <!-- Schedule of Program (included Modules)-->
      <component
        :is="viewMode === 'week' ? 'ScheduleProgramWeek' : 'ScheduleProgramDay'"
        ref="scheduleProgram"
        @edit-module="editModule"
        :programData="programData"
        :programId="programId"
        @delete-module="handleDeleteModule"
        :numberOfWeeks="numberOfWeeks"
      />

      <!-- Modal Thêm/Sửa Module -->
      <b-modal
        id="module-modal"
        ref="moduleModal"
        :title="isEditing ? 'Cập nhật Module' : 'Thêm module'"
        size="lg"
        hide-footer
        @hidden="resetModuleForm"
      >
        <div class="form-container">
          <div class="form-row d-flex">
            <div class="form-row w-100">
              <div class="form-group" style="flex: 9">
                <label>
                  Tên module hoặc mã module
                  <span style="color: red">*</span>
                </label>
                <basic-select
                  placeholder="Loại bài học"
                  name="type"
                  :solid="false"
                  changeValueByObject
                  trackBy="value"
                  valueLabel="text"
                  :options="modules"
                  :value.sync="selectedModule"
                />
              </div>
              <div class="form-group" style="flex: 3">
                <label>Tuần bắt đầu</label>
                <select v-model="moduleForm.startWeek" class="form-input">
                  <option
                    v-for="week in numberOfWeeks"
                    :key="week"
                    :value="week"
                  >
                    Tuần {{ week }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-actions mt-4">
            <b-button
              variant="success"
              @click="handleSubmitModule"
              class="mr-2"
            >
              {{ isEditing ? 'Cập nhật' : 'Thêm module' }}
            </b-button>
            <b-button variant="secondary" @click="hideModal"> Hủy </b-button>
          </div>
        </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import ScheduleProgramWeek from './components/ScheduleProgramWeek.vue';
import ScheduleProgramDay from './components/ScheduleProgramDay.vue';

export default {
  components: {
    ScheduleProgramWeek,
    ScheduleProgramDay,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      selectedModule: '',
      modules: [],
      programData: {},
      viewMode: 'week', // 'week' hoặc 'day'
      moduleForm: this.getDefaultModuleForm(),
      isEditing: false,
      editingId: null,
      numberOfWeeks: 10, // Số tuần mặc định
    };
  },
  computed: {
    programId() {
      return this.id || this.$route.params.id;
    },
    scheduleProgram() {
      return this.$refs.scheduleProgram;
    },
  },
  methods: {
    // Các phương thức điều hướng
    returnPage() {
      this.$router.push({ name: 'program_list' });
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === 'week' ? 'day' : 'week';
    },

    // Các phương thức tiện ích
    getDefaultModuleForm() {
      return {
        startWeek: 1,
        duration: 1,
        type: '',
        color: '#16A45A',
        moduleProgramMappingId: '',
      };
    },

    updateModules(modules) {
      this.modules = modules;
    },
    getStartDay(startWeek) {
      // Ngày bắt đầu của tuần là (startWeek - 1) * 7 + 1
      // Ví dụ: Tuần 1 bắt đầu từ ngày 1, tuần 2 bắt đầu từ ngày 8
      return (startWeek - 1) * 7 + 1;
    },

    // Xử lý modal
    showAddModuleModal() {
      this.resetModuleForm();
      this.$refs.moduleModal.show();
    },
    hideModal() {
      this.$refs.moduleModal.hide();
    },
    resetModuleForm() {
      this.moduleForm = this.getDefaultModuleForm();
      this.selectedModule = '';
      this.isEditing = false;
      this.editingId = null;
    },
    editModule(module) {
      this.isEditing = true;
      this.editingId = module.id;
      this.moduleForm = { ...this.getDefaultModuleForm(), ...module };
      this.selectedModule =
        this.modules.find(
          (m) => m.value === module.id || m.value === module.type,
        ) || '';
      this.$refs.moduleModal.show();
    },

    // Xác thực form
    validateModuleForm() {
      if (!this.selectedModule) {
        this.$swal('Lỗi!', 'Vui lòng chọn module', 'error');
        return false;
      }

      const maxWeek = this.moduleForm.startWeek + this.selectedModule.totalWeek;

      if (maxWeek > this.numberOfWeeks + 1) {
        return new Promise((resolve) => {
          this.$swal({
            title: 'Cảnh báo!',
            text: `Module này kéo dài đến tuần ${
              maxWeek - 1
            }, vượt quá số tuần hiện tại ${
              this.numberOfWeeks
            }. Bạn có muốn mở rộng thêm số tuần không?`,
            icon: 'warning',
            buttons: {
              cancel: {
                text: 'Không, tôi sẽ điều chỉnh lại',
                value: false,
                visible: true,
                className: 'btn btn-secondary',
                closeModal: true,
              },
              confirm: {
                text: 'Có, mở rộng số tuần',
                value: true,
                visible: true,
                className: 'btn btn-primary',
                closeModal: true,
              },
            },
          }).then((result) => {
            if (result) {
              this.updateNumberOfWeeks(maxWeek - 1);
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      }
      return true;
    },
    updateNumberOfWeeks(newWeeks) {
      this.numberOfWeeks = newWeeks;
      // Cập nhật numberOfWeeks cho Program (nếu cần)
      if (this.programId) {
        this.updateProgramNumberOfWeeks(this.numberOfWeeks).catch((error) => {
          console.error('Lỗi khi cập nhật số tuần cho program:', error);
          this.$swal(
            'Cảnh báo',
            'Số tuần đã được cập nhật trên giao diện nhưng chưa được lưu vào cơ sở dữ liệu. Vui lòng thử lại hoặc làm mới trang.',
            'warning',
          );
        });
      }
    },
    // Thêm phương thức mới để cập nhật totalWeek của Program
    async updateProgramNumberOfWeeks(numberOfWeeks) {
      try {
        const formData = new FormData();
        formData.append('totalWeek', numberOfWeeks);
        // Gọi API để cập nhật totalWeek của Program
        await this.$api.put(`Program/${this.programId}`, formData);
      } catch (error) {
        console.error('Lỗi khi cập nhật số tuần:', error);
        throw error;
      }
    },
    async handleSubmitModule() {
      const validationResult = this.validateModuleForm();

      if (validationResult instanceof Promise) {
        const isValid = await validationResult;
        if (!isValid) return;
      } else if (!validationResult) {
        return;
      }

      // Chuẩn bị dữ liệu module
      const moduleTitle =
        this.modules.find((m) => m.value === this.selectedModule.value)?.text ||
        '';

      const moduleData = {
        ...this.moduleForm,
        title: moduleTitle,
        type: this.selectedModule.value,
        id: this.editingId || '',
        duration: this.selectedModule.totalWeek || 1,
        color: this.selectedModule.color, // Add this line to use the module's color
      };

      try {
        // this.loading = true;

        if (this.isEditing) {
          this.updateExistingModule(moduleData);
        } else {
          this.createNewModule(moduleData);
        }

        this.hideModal();
        this.$swal(
          'Thành công!',
          `Đã ${this.isEditing ? 'cập nhật' : 'thêm'} module thành công`,
          'success',
        );
        this.viewMode = 'week';
      } catch (error) {
        this.$swal('Lỗi!', error.message || 'Đã có lỗi xảy ra', 'error');
      } finally {
        // this.loading = false;
      }
    },
    updateModuleMappingId(moduleType, mappingId) {
      if (this.scheduleProgram && this.scheduleProgram.events) {
        // Tìm module với type tương ứng
        const index = this.scheduleProgram.events.findIndex(
          (e) => e.type === moduleType,
        );

        if (index !== -1) {
          // Tạo bản sao để kích hoạt reactivity
          let events = [...this.scheduleProgram.events];
          events[index].moduleProgramMappingId = mappingId;
          this.scheduleProgram.events = events;
        }
      }
    },
    getStartWeek(startAtDay) {
      // Nếu startAtDay là null, undefined hoặc 0, mặc định là tuần 1
      if (!startAtDay) return 1;

      // Tính tuần bằng cách chia (startAtDay - 1) cho 7 và cộng thêm 1
      // Điều này đảm bảo ngày 1-7 thuộc tuần 1, ngày 8-14 thuộc tuần 2, v.v.
      return Math.floor((startAtDay - 1) / 7) + 1;
    },
    async createNewModule(moduleData) {
      // Generate a temporary ID for immediate UI update
      const tempId = `temp-${Date.now()}`;

      // Create a copy of moduleData with the temporary ID
      const tempModuleData = {
        ...moduleData,
        moduleProgramMappingId: tempId,
      };

      // Update UI immediately
      this.scheduleProgram.addModule(tempModuleData);

      // Add to programData for cross-view persistence
      const tempModuleForProgram = {
        id: moduleData.id,
        name: moduleData.title,
        startAtDay: this.getStartDay(moduleData.startWeek),
        totalWeek: moduleData.duration,
        type: moduleData.type,
        color: moduleData.color,
        moduleProgramMappingId: tempId,
      };

      this.programData = {
        ...this.programData,
        modules: [...(this.programData.modules || []), tempModuleForProgram],
      };

      try {
        // Call API in the background
        const mappingId = await this.createProgramModuleMappings(
          moduleData.type,
          this.getStartDay(moduleData.startWeek),
        );

        // Update the real ID in the component and programData
        if (this.scheduleProgram && this.scheduleProgram.events) {
          this.scheduleProgram.events = this.scheduleProgram.events.map(
            (event) => {
              if (event.moduleProgramMappingId === tempId) {
                return { ...event, moduleProgramMappingId: mappingId };
              }
              return event;
            },
          );
        }

        if (this.programData && this.programData.modules) {
          this.programData.modules = this.programData.modules.map((module) => {
            if (module.moduleProgramMappingId === tempId) {
              return { ...module, moduleProgramMappingId: mappingId };
            }
            return module;
          });
        }
      } catch (error) {
        // Handle error - revert UI changes
        console.error('Error creating module:', error);

        // Remove the temporary module from UI
        if (this.scheduleProgram && this.scheduleProgram.events) {
          this.scheduleProgram.events = this.scheduleProgram.events.filter(
            (event) => event.moduleProgramMappingId !== tempId,
          );
        }

        if (this.programData && this.programData.modules) {
          this.programData.modules = this.programData.modules.filter(
            (module) => module.moduleProgramMappingId !== tempId,
          );
        }

        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi tạo module, vui lòng thử lại.',
          'error',
        );
      }
    },

    async updateExistingModule(moduleData) {
      // Store original data for rollback if needed
      let originalModule = null;

      if (this.programData && this.programData.modules) {
        originalModule = this.programData.modules.find(
          (m) => m.moduleProgramMappingId === moduleData.moduleProgramMappingId,
        );
      }

      // Update UI immediately
      this.scheduleProgram.updateModule(moduleData);

      // Update programData for cross-view persistence
      if (this.programData && this.programData.modules) {
        const moduleIndex = this.programData.modules.findIndex(
          (m) => m.moduleProgramMappingId === moduleData.moduleProgramMappingId,
        );

        if (moduleIndex !== -1) {
          const updatedModules = [...this.programData.modules];
          updatedModules[moduleIndex] = {
            id: moduleData.id,
            name: moduleData.title,
            startAtDay: this.getStartDay(moduleData.startWeek),
            totalWeek: moduleData.duration,
            type: moduleData.type,
            color: moduleData.color,
            moduleProgramMappingId: moduleData.moduleProgramMappingId,
          };

          this.programData = {
            ...this.programData,
            modules: updatedModules,
          };
        }
      }

      try {
        // Call API in the background
        const data = {
          ProgramModuleId: moduleData.type,
          programId: this.programId,
          startAtDay: this.getStartDay(moduleData.startWeek),
        };

        await this.editProgramModuleMappings(
          moduleData.moduleProgramMappingId,
          data,
        );
      } catch (error) {
        console.error('Error updating module:', error);

        // Roll back UI changes if API call fails
        if (originalModule && this.programData && this.programData.modules) {
          const moduleIndex = this.programData.modules.findIndex(
            (m) =>
              m.moduleProgramMappingId === moduleData.moduleProgramMappingId,
          );

          if (moduleIndex !== -1) {
            const updatedModules = [...this.programData.modules];
            updatedModules[moduleIndex] = originalModule;

            this.programData = {
              ...this.programData,
              modules: updatedModules,
            };
          }

          // Update UI back to original
          if (this.scheduleProgram) {
            const originalUIModule = {
              id: originalModule.id,
              title: originalModule.name,
              startWeek: this.getStartWeek(originalModule.startAtDay),
              duration: originalModule.totalWeek,
              type: originalModule.type,
              color: originalModule.color,
              moduleProgramMappingId: originalModule.moduleProgramMappingId,
            };

            this.scheduleProgram.updateModule(originalUIModule);
          }
        }

        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi cập nhật module, vui lòng thử lại.',
          'error',
        );
      }
    },

    async handleDeleteModule(moduleProgramMappingId) {
      // Store deleted module for potential rollback
      let deletedModule = null;
      let deletedUIModule = null;

      if (this.programData && this.programData.modules) {
        deletedModule = this.programData.modules.find(
          (module) => module.moduleProgramMappingId === moduleProgramMappingId,
        );
      }

      if (this.scheduleProgram && this.scheduleProgram.events) {
        deletedUIModule = this.scheduleProgram.events.find(
          (event) => event.moduleProgramMappingId === moduleProgramMappingId,
        );

        // Update UI immediately
        this.scheduleProgram.events = this.scheduleProgram.events.filter(
          (event) => event.moduleProgramMappingId !== moduleProgramMappingId,
        );
      }

      // Update programData for cross-view persistence
      if (this.programData && this.programData.modules) {
        this.programData.modules = this.programData.modules.filter(
          (module) => module.moduleProgramMappingId !== moduleProgramMappingId,
        );
      }

      try {
        this.$swal('Thành công!', 'Đã xóa module thành công', 'success');
        // Call API in the background
        this.$api.delete(`ProgramProgramModule/${moduleProgramMappingId}`);

        // Show success message
      } catch (error) {
        console.error('Error deleting module:', error);

        // Roll back UI changes if API call fails
        if (deletedModule && this.programData) {
          this.programData.modules = [
            ...this.programData.modules,
            deletedModule,
          ];
        }

        if (deletedUIModule && this.scheduleProgram) {
          this.scheduleProgram.events = [
            ...this.scheduleProgram.events,
            deletedUIModule,
          ];
        }

        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi xóa module, vui lòng thử lại.',
          'error',
        );
      }
    },
    // API requests
    async loadProgramData() {
      if (!this.programId) return;

      try {
        const { data } = await this.$api.get(`Program/${this.programId}`);
        this.programData = data;
        this.numberOfWeeks = data.totalWeek || this.numberOfWeeks;
        return data; // Return data for Promise.all to handle
      } catch (error) {
        console.error('Error loading program data:', error);
        throw error; // Throw error so Promise.all can catch it
      }
    },

    async loadModulesData() {
      try {
        const { data } = await this.$api.get(`ProgramModule/All`);
        this.modules = data.map((item) => ({
          text: item?.name,
          totalWeek: item?.totalWeek,
          value: item?.id,
          color: item.color,
        }));
        return data; // Return data for Promise.all to handle
      } catch (error) {
        console.error('Error loading modules data:', error);
        throw error; // Throw error so Promise.all can catch it
      }
    },
    async createProgramModuleMappings(programModuleId, startAtDay) {
      if (!this.programId) throw new Error('Không tìm thấy ID chương trình');

      const formData = new FormData();
      formData.append('ProgramId', this.programId);
      formData.append('programModuleId', programModuleId);
      formData.append('startAtDay', startAtDay);

      // Gửi API request
      const { data } = await this.$api.post(`ProgramProgramModule`, formData);
      return data;
    },

    async editProgramModuleMappings(id, data) {
      return await this.$api.put(`ProgramProgramModule/${id}`, data);
    },

    async inactiveItem(item) {
      const payload = new FormData();
      payload.append('id', item.id);
      payload.append('active', !item.isActive);
      return await this.$api.put(`Program`, payload);
    },

    handleInactive(item) {
      const text = item.isActive ? 'Inactive' : 'Active';
      const btn = item.isActive ? 'btn-inactive' : 'btn-active';

      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then((result) => {
        if (result) {
          this.inactiveItem(item)
            .then(() => {
              this.loadProgramData();
              this.$swal(
                'Thành công!',
                'Chúc mừng, bạn đã cập nhật thông tin Program thành công!',
                'success',
              );
            })
            .catch(() => {
              this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
            });
        }
      });
    },
  },
  mounted() {
    this.loading = true; // Set loading to true before starting API calls

    // Use Promise.all to wait for both API calls to complete
    Promise.all([this.loadProgramData(), this.loadModulesData()])
      .then(() => {
        console.log('All data loaded successfully');
      })
      .catch((error) => {
        console.error('Error loading data:', error);
        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi tải dữ liệu, vui lòng thử lại.',
          'error',
        );
      })
      .finally(() => {
        this.loading = false; // Set loading to false after all API calls are done
      });
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: 600;
}

.header-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navigation-buttons {
  display: flex;
  align-items: center;
}

.form-container {
  padding: 10px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.form-group {
  flex: 1;
  min-width: 200px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

.custom-btn {
  border: 1px solid #008479 !important;
  color: #008479 !important;
  background-color: transparent;
}

.toggle-text.active {
  font-weight: bold;
}
::v-deep .b-overlay .spinner-border {
  width: 4rem !important;
  height: 4rem !important;
  border-width: 0.3em !important;
}
::v-deep .b-overlay {
  min-height: 100vh;
}
::v-deep .b-overlay > .position-absolute {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
